import { useMemo } from 'react'
import { runtimeEnv } from '@/utils/runtimeEnv'
import { toAbsoluteMediaUrls } from '@/utils/mediaReferences'

/** Prefixes relative /api/media/ references with the API base URL. */
export function processMediaUrls(html: string | undefined | null): string {
  return toAbsoluteMediaUrls(html, runtimeEnv.VITE_API_BASE_URL || '')
}

export function useProcessMediaUrls(html: string | undefined | null): string {
  const baseUrl = runtimeEnv.VITE_API_BASE_URL || ''
  return useMemo(() => toAbsoluteMediaUrls(html, baseUrl), [html, baseUrl])
}
